'use es6';

import { curry } from 'rich-text-lib/utils/iterables';
import { closest } from 'foundations-components/transitional/utils/dom';
export const isHubSpotUI = curry(function isHubSpotUI(namespace, el) {
  if (!el || el.nodeType !== Node.ELEMENT_NODE) {
    return false;
  }
  const hasMceClassname = typeof el.className === 'string' && el.className.indexOf(namespace) > -1;
  const hasTinymceFloatingElementDataAttribute = el.dataset && !!el.dataset['tinymceFloatingElement'];
  if (hasMceClassname || hasTinymceFloatingElementDataAttribute) {
    return true;
  }
  if (el.parentNode && el.parentNode.nodeType === 1) {
    return isHubSpotUI(namespace, el.parentNode);
  }
  return false;
});
export const isMceUI = el => {
  return closest(el, '[class*=mce-],[data-tinymce-floating-element]') !== null;
};